import React from 'react';
import { FiLoader } from 'react-icons/fi';
import styles from '../Auth.module.css';

/**
 * SocialAuthButton - Button for social authentication (Google, etc.)
 */
const SocialAuthButton = ({
  provider = 'google',
  loading = false,
  disabled = false,
  onClick,
  children,
}) => {
  const getProviderLogo = () => {
    switch (provider) {
      case 'google':
        return '/google-logo.png';
      default:
        return null;
    }
  };

  const getDefaultText = () => {
    switch (provider) {
      case 'google':
        return 'Continue with Google';
      default:
        return 'Continue';
    }
  };

  return (
    <button
      type="button"
      className={`${styles['au-btn']} ${styles['au-btn--social']}`}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? (
        <>
          <FiLoader className={styles['au-btn__spinner']} />
          <span>Connecting...</span>
        </>
      ) : (
        <>
          {getProviderLogo() && (
            <img 
              src={getProviderLogo()} 
              alt={provider} 
            />
          )}
          <span>{children || getDefaultText()}</span>
        </>
      )}
    </button>
  );
};

export default SocialAuthButton;
